<template>
  <div class="popular-questions--container">
    <div class="popular-question--item">
      <div @click="toggleShow(0)" class="title">
        &#8226; Как настроить работу сервиса после регистрации?
      </div>
      <div v-if="list[0]" class="text">
        <p>
          Для того, чтобы выполнить первоначальную настройку сервиса, необходимо
          последовательно заполнить следующие разделы:
        </p>
        <ul>
          <li>
            Перейти в раздел "Компании/Филиалы" и создать свою первую компанию.
          </li>
          <li>
            Перейти в раздел "Услуги" и создать по крайней мере 1 услугу
          </li>
          <li>
            Перейти в раздел "Сотрудники" и создать по крайней мере 1 сотрудника
          </li>
          <li>
            Перейти в раздел "Расписание" и задать график работы сотрудника
          </li>
        </ul>
        <p>
          Готово! Можно переходить в "Журнал записей" и полноценно работать с программой
        </p>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(1)" class="title">
        &#8226; Как мне найти свою ссылку на страницу записи онлайн?
      </div>
      <div v-if="list[1]" class="text">
        <p>
          Для этого просто перейдите в раздел "Запись онлайн". Там первым пунктом вы увидите
          карточку(-и) вашей компании в которой будет ссылка на запись.
        </p>
        <p>
          Кстати, помимо кнопки "Копировать", которая копирует ссылку в буфер обмена устройства, 
          есть еще кнопка "Диагностика", при нажатии на которую, система может подсказать, что вы
          забыли заполнить, либо же наоборот, все настроено верно и ссылка работает.
        </p>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(2)" class="title">
        &#8226; Я создал новую услугу, но она не отображается на странице записи онлайн
      </div>
      <div v-if="list[2]" class="text">
        <p>
          Скорее всего вы не присвоили услугу сотруднику. Программа не знает, кто ее может оказать, 
          поэтому не предлагает. Перейдите в раздел "Сотрудники", нажмите "Изменить" на необходимом
          сотруднике и прокликайте актуальный набор услуг, включая новую. Далее "Сохранить".
        </p>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(3)" class="title">
        &#8226; Перестали приходить E-mail уведомления
      </div>
      <div v-if="list[3]" class="text">
        <p>
          Причин может быть несколько:
        </p>
        <ul>
          <li>
            Убедитесь, что уведомления включены. Для этого перейдите в раздел
            "Настройки" -> "Уведомления" -> "E-mail уведомления" и проверьте везде ли
            отмечены чек-боксы, где вам необходимо.
          </li>
          <li>
            Письмо попало в папку "Спам". Просто добавьте наш e-mail в список доверительных
            в вашем почтовом сервисе. (Не переживайте, что и у ваших клиентов уведомления могут
            попадать в спам. Для них мы используем платные каналы рассылки)
          </li>
          <li>
            Вероятно, вы или ваш клиент нажали на одном из наших писем ссылку "Отписаться" и попали в стоп-лист.
            В таком случае, напишите сообщение в поддержку, чтобы убрать вас оттуда.
          </li>
        </ul>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(4)" class="title">
        &#8226; Мне нужно отправить в чат поддержки скриншот/видеозапись
      </div>
      <div v-if="list[4]" class="text">
        <p>
          Это можно сделать письмом на электронный адрес <b>info@enroller.ru</b>
        </p>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(5)" class="title">
        &#8226; Как мне создать групповые записи?
      </div>
      <div v-if="list[5]" class="text">
        <p>
          К сожалению, у нас пока что нет функции групповых записей, но в планах на начало-середину 2023 года.
        </p>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(6)" class="title">
        &#8226; Могу ли я брать оплату/предоплату с клиентов через ваш сервис?
      </div>
      <div v-if="list[6]" class="text">
        <p>
          К сожалению, пока что данной функции у нас нет.
        </p>
      </div>
    </div>
    <div class="popular-question--item">
      <div @click="toggleShow(7)" class="title">
        &#8226; Клиенту не приходят СМС-сообщения
      </div>
      <div v-if="list[7]" class="text">
        <p>
          Причин для этого может быть несколько:
        </p>
        <p>
          1. Проверьте, является ли ваш пакетный баланс СМС положительным.
        </p>
        <p>
          2. Проверьте включена ли у вас отправка уведомлений.
        </p>
        <p>
          3. Возможно у вас включена функция "Экономные уведомления" и уведомление клиенту было отправлено
          другим способом. Можно открыть запись и посмотреть в истории записи было ли отправлено уведомление 
          и каким способом.
        </p>
      </div>
    </div>
    <!-- <div class="hint mrg-t-25">
      У нас есть небольшой обучающий видеокурс по работе с программой в разделе 
      "Обучение". Он поможет вам начать полноценную работу с сервисом, а также 
      снизит временные затраты на обучение ваших новых сотрудников.
    </div> -->
  </div>
</template>

<script>


export default {
  name: "PopularQuestions",
  components: {},
  data() {
    return {
      list: [false, false, false, false, false, false, false, false]
    };
  },
  props: {
    
  },
  watch: {
    
  },
  computed: {

  },
  methods: {
    toggleShow(idx){
      this.$set(this.list, idx, !this.list[idx]);
    }
  }
};
</script>

<style scoped lang="less">
.popular-question--item{
  margin-top: 20px;

  .title{
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
  }
  .text{
    padding-left: 15px;
    box-sizing: border-box;

    li{
      margin-top: 10px;
    }
  }
}
</style>
